<template>
  <div class="debtDetail">
    <div class="header" v-if="currencyList && currencyList.length > 0">
      <van-row class="currency-row">
        <van-col span="6"></van-col>
        <van-col span="6" v-for="(currency, index) in currencyList" :key="index">{{
          currency.CurrencySn
        }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.salesManagement.subTotal }}</van-col>
        <van-col span="6" v-for="(amount, index) in currencyList" :key="index">{{
          amount.TotalAmount
        }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.salesManagement.rate }}</van-col>
        <van-col span="6" v-for="(amount, index) in rateList" :key="index">{{
          amount.Rate
        }}</van-col>
      </van-row>
      <van-row class="amount-row">
        <van-col span="6">{{ $t.salesManagement.unreceiveTotal }}</van-col>
        <van-col span="6"></van-col>
        <van-col span="6">{{ totalReceivable }}</van-col>
        <van-col span="6"></van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.salesManagement.invoiceNo }}：{{ item.InvoiceNo }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.createDate }}：{{ item.CreateTime }}
        </div>
        <div class="list-item">
          {{ $t.salesManagement.billTotal }}：{{ item.TotalAmount }}
        </div>
        <div class="list-item">{{ $t.salesManagement.deliveryPort }}：{{ item.POL }}</div>
        <div class="list-item">
          {{ $t.salesManagement.destinationPort }}：{{ item.POD }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="toBillsReceivable(item.InvoiceNo)"
            >{{ $t.meta.viewDetail }}</van-button
          >
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import Vue from "vue";
import { List, Row, Col, Button } from "vant";

Vue.use(List).use(Row).use(Col).use(Button);

export default {
  name: "debtDetail",
  data() {
    return {
      WB_Number: "",
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      currencyList: {},
      rateList: {},
      totalReceivable: null,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  created() {
    const { WB_Number } = this.$route.query;
    this.WB_Number = WB_Number;
  },
  methods: {
    toBillsReceivable(InvoiceNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: InvoiceNo,
          },
          {
            name: "IsExternal",
            value: true,
          },
        ],
      });
    },
    getList() {
      return new Promise((resolve) => {
        var param = {
          CustomerId: this.CustomerId,
          WB_Number: this.WB_Number,
        };
        this.$api.myCustomer
          .getFreightBillPayableList(param)
          .then((res) => {
            var data = res.data;
            this.currencyList = data.SubTotalList;
            this.rateList = data.RateList;
            this.totalReceivable = data.TotalReceivable;
            this.tableData = this.tableData.concat(data.FreightBillList);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.finished = true;
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.debtDetail {
  display: inline-block;
  width: 100%;

  .header {
    padding: 10px;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;

    .currency-row {
      background: #009ed4;
      color: white;

      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }

    .amount-row {
      .van-col {
        padding-left: 10px;
        line-height: 35px;
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .list-item:last-child {
        margin-bottom: 0px;
      }

      .buttons {
        text-align: right;

        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
